var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10,2.5c0-1.381,1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5-1.119,2.5-2.5,2.5-2.5-1.119-2.5-2.5Zm10.895,11.244c-.176.351-.528.553-.896.553-.15,0-.303-.034-.446-.105l-2.842-1.421c-.654-.327-1.207-.827-1.597-1.447l-.494-.784-1.408,5.296,1.27.721c.937.533,1.518,1.532,1.518,2.609v3.836c0,.552-.447,1-1,1s-1-.448-1-1v-3.836c0-.359-.194-.692-.506-.87l-3.977-2.258c-1.148-.652-1.74-2.006-1.439-3.292l1.026-4.385c-.207.076-.41.162-.607.26l-2.097,1.049c-.257.128-.446.36-.519.638l-.783,2.951c-.142.534-.689.85-1.223.71-.534-.142-.852-.689-.71-1.223l.783-2.951c.221-.832.789-1.53,1.559-1.914l2.096-1.049c1.087-.543,2.303-.83,3.518-.83h.879c2.006,0,3.273,1.829,3.327,1.907l1.48,2.351c.194.31.47.56.797.723l2.843,1.422c.494.247.694.848.447,1.342Zm-9.438,1.093l1.667-6.369c-.295-.238-.688-.467-1.124-.467h-.758l-1.217,5.2c-.1.428.097.879.48,1.097l.951.54Zm-2.266,3.029c-.008-.005-.016-.01-.024-.014-.568-.34-1.304-.029-1.454.616l-.153.661-1.61,3.452c-.308.661.174,1.419.904,1.419.386,0,.738-.223.903-.573l1.654-3.514.228-.993c.095-.412-.086-.838-.449-1.055Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.63083dcdb1c1981bb6573ed7be520ec9.svg";
export { ForwardRef as ReactComponent };